import React from 'react';

export interface TableColumn<T = Record<string, unknown>> {
  key: string;
  label: string | React.ReactNode;
  align?: 'left' | 'center' | 'right';
  render?: (value: unknown, row: T, rowIndex: number, colIndex: number) => React.ReactNode;
}

export interface TableProps<T = Record<string, unknown>> {
  columns: TableColumn<T>[];
  data: T[];
  className?: string;
  headerClassName?: string;
  rowClassName?: string;
}

const Table = <T extends object = Record<string, unknown>>({ columns, data, className = '' }: TableProps<T>) => (
  <table className={`owg-table w-full border-collapse ${className}`}>
    <thead>
      <tr className="border-b bg-[#F8F8F8]">
        {columns.map((col) => (
          <th key={col.key} className={`px-4 py-2 text-${col.align || 'left'}`}>
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.map((row, rowIdx) => (
        <tr key={rowIdx} className={`border-b border-ow-lighter-grey ${rowIdx % 2 !== 0 ? 'bg-[#FCFCFC]' : 'bg-white'}`}>
          {columns.map((col, colIdx) => {
            const value = (row as Record<string, unknown>)[col.key];
            const displayValue = col.render ? col.render(value, row, rowIdx, colIdx) : String(value ?? '');
            return (
              <td key={col.key} className={`px-4 py-2 text-${col.align || 'left'}`}>
                {displayValue}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  </table>
);

export default Table;
